module.exports = __webpack_public_path__ + "static/media/gpv-telehealth.2be9ba8d.png";